"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
(0, core_1.addRoute)({
    name: "workSummary",
    path: "/worksheets-work-summary",
    component: "WorkSummaryView"
});
let WorkSummaryView = class WorkSummaryView extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
        this.$$cache_params = new core_1.ComponentValueCache(this, "params", "WorkSummaryViewFilter");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    selectedItems;
    params;
    async $$load_params() {
        return {
            date_from: this.$fn.today(),
            date_to: null,
        };
    }
    ux;
    b_7315092382398562_modalBindings;
    b_2248226175642056_headerShowReloadButton;
    b_2248226175642056_columnDefaults;
    b_2248226175642056_columns;
    b_6466705138206980_style;
    dataMembers = ['selectedItems', 'params', 'ux', 'b_7315092382398562_modalBindings', 'b_2248226175642056_headerShowReloadButton', 'b_2248226175642056_columnDefaults', 'b_2248226175642056_columns', 'b_6466705138206980_style'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                selectedItems: [],
                params: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "sm",
                },
                b_2248226175642056_headerShowReloadButton: false,
                b_2248226175642056_columnDefaults: {
                    sortable: true,
                    filterable: true,
                    resizable: true,
                },
                b_2248226175642056_columns: [{
                        field: "service_name",
                        name: this.$fn.pgettext("WorkSummaryView", "Service name"),
                        type: "command",
                        formatter: {
                            name: "routeLink",
                            to: "product",
                            navigateOnIconClick: true,
                            params: {
                                id: "service_id",
                            },
                        },
                    },
                    {
                        field: "unit",
                        name: this.$fn.pgettext("WorkSummaryView", "unit"),
                    },
                    {
                        field: "quantity",
                        name: this.$fn.pgettext("WorkSummaryView", "Quantity"),
                        type: "number",
                        formatter: "number",
                    },
                    {
                        field: "net_amount",
                        name: this.$fn.pgettext("WorkSummaryView", "Net"),
                        type: "number",
                        formatter: "number",
                    },
                    {
                        field: "vat_amount",
                        name: this.$fn.pgettext("WorkSummaryView", "VAT"),
                        type: "number",
                        formatter: "number",
                    },
                    {
                        field: "amount",
                        name: this.$fn.pgettext("WorkSummaryView", "Amount"),
                        type: "number",
                        formatter: "number",
                    },
                    {
                        field: "rental_name",
                        name: this.$fn.pgettext("WorkSummaryView", "Rental"),
                        type: "command",
                        formatter: {
                            name: "routeLink",
                            to: "rental",
                            navigateOnIconClick: true,
                            params: {
                                id: "rental_id",
                            },
                        },
                    },
                    {
                        field: "company_name",
                        name: this.$fn.pgettext("WorkSummaryView", "Company"),
                        formatter: {
                            name: "routeLink",
                            to: "company",
                            navigateOnIconClick: true,
                            params: {
                                id: "company_id",
                            },
                        },
                    },
                    {
                        field: "client_name",
                        width: "200px",
                        name: this.$fn.pgettext("WorkSummaryView", "Company"),
                        formatter: {
                            name: "routeLink",
                            to: "company",
                            navigateOnIconClick: true,
                            params: {
                                id: "client_id",
                            },
                        },
                    },
                    {
                        field: "contractor_name",
                        width: "200px",
                        name: this.$fn.pgettext("WorkSummaryView", "Contractor"),
                        formatter: {
                            name: "routeLink",
                            to: "company",
                            navigateOnIconClick: true,
                            params: {
                                id: "contractor_id",
                            },
                        },
                    },
                ],
                b_6466705138206980_style: {
                    width: "500px",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("WorkSummaryView", "Work summary"),
                icon: this.$config.worksheet.icon,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_8214_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_setData_8216_getActionArgs($event) {
        return {
            path: "selectedItems",
            value: this.$refs.grid.getSelectedItems(),
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_2248226175642056_selectedRowsChanged(event, scope) {
        return await this.actions.evh_2248226175642056_selectedRowsChanged.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_showModal_8218_getActionArgs($event) {
        return {
            name: "Payment",
            props: {
                modal: true,
                oid: $event.data.data.id,
            },
        };
    }
    async evh_2248226175642056_command_8217_getWhen($event) {
        return $event.data.column.id === 'transaction_number';
    }
    async evh_2248226175642056_command(event, scope) {
        return await this.actions.evh_2248226175642056_command.executeFromDOM(this, event, scope);
    }
    async act_6466705138206980_setData_8220_getActionArgs($event) {
        return {
            path: "params.date_from",
            value: $event.data[0],
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_6466705138206980_setData_8222_getActionArgs($event) {
        return {
            path: "params.date_to",
            value: $event.data[1],
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_6466705138206980_changed(event, scope) {
        return await this.actions.evh_6466705138206980_changed.executeFromDOM(this, event, scope);
    }
    async act_4440454779651433_script_8224_getActionArgs_value($event) {
        this.$refs.grid.reload();
    }
    async act_4440454779651433_script_8224_getActionArgs($event) {
        return {
            value: () => this.act_4440454779651433_script_8224_getActionArgs_value($event),
        };
    }
    async evh_4440454779651433_clickPreventStop(event, scope) {
        return await this.actions.evh_4440454779651433_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_8214 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_8214_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_8213 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_8214,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_8213],
        });
        const act_2248226175642056_setData_8216 = new core_1.actions.SetDataAction({
            actionArgs: this.act_2248226175642056_setData_8216_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_selectedRowsChanged_8215 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_setData_8216,
            event: "selectedRowsChanged",
            displayName: "setData",
        });
        const evh_2248226175642056_selectedRowsChanged = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_selectedRowsChanged_8215],
        });
        const act_2248226175642056_showModal_8218 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_2248226175642056_showModal_8218_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_command_8217 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_showModal_8218,
            event: "command",
            when: this.evh_2248226175642056_command_8217_getWhen,
            displayName: "showModal",
        });
        const evh_2248226175642056_command = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_command_8217],
        });
        const act_6466705138206980_setData_8220 = new core_1.actions.SetDataAction({
            actionArgs: this.act_6466705138206980_setData_8220_getActionArgs,
            events: [],
        });
        const evh_6466705138206980_changed_8219 = new core_1.actions.EventHandlerImpl({
            action: act_6466705138206980_setData_8220,
            event: "changed",
            displayName: "setData",
        });
        const act_6466705138206980_setData_8222 = new core_1.actions.SetDataAction({
            actionArgs: this.act_6466705138206980_setData_8222_getActionArgs,
            events: [],
        });
        const evh_6466705138206980_changed_8221 = new core_1.actions.EventHandlerImpl({
            action: act_6466705138206980_setData_8222,
            event: "changed",
            displayName: "setData",
        });
        const evh_6466705138206980_changed = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6466705138206980_changed_8219, evh_6466705138206980_changed_8221],
        });
        const act_4440454779651433_script_8224 = new core_1.actions.ScriptAction({
            actionArgs: this.act_4440454779651433_script_8224_getActionArgs,
            events: [],
        });
        const evh_4440454779651433_clickPreventStop_8223 = new core_1.actions.EventHandlerImpl({
            action: act_4440454779651433_script_8224,
            event: "click.prevent.stop",
            displayName: "script",
        });
        const evh_4440454779651433_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4440454779651433_clickPreventStop_8223],
        });
        return {
            act_7315092382398562_closeModal_8214,
            evh_7315092382398562_close_8213,
            evh_7315092382398562_close,
            act_2248226175642056_setData_8216,
            evh_2248226175642056_selectedRowsChanged_8215,
            evh_2248226175642056_selectedRowsChanged,
            act_2248226175642056_showModal_8218,
            evh_2248226175642056_command_8217,
            evh_2248226175642056_command,
            act_6466705138206980_setData_8220,
            evh_6466705138206980_changed_8219,
            act_6466705138206980_setData_8222,
            evh_6466705138206980_changed_8221,
            evh_6466705138206980_changed,
            act_4440454779651433_script_8224,
            evh_4440454779651433_clickPreventStop_8223,
            evh_4440454779651433_clickPreventStop,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], WorkSummaryView.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], WorkSummaryView.prototype, "onSize", null);
WorkSummaryView = __decorate([
    (0, vue_property_decorator_1.Component)()
], WorkSummaryView);
exports.default = WorkSummaryView;
vue_property_decorator_1.Vue.component("WorkSummaryView", WorkSummaryView);
